import { css } from "styled-components";

export const v = {
    sidebarWhidth: `20vw`,
    smSpacing: `8px`,
    mdSpacing: `16px`,
    lgSpacing: `20px`,
    xSpacing: `32px`,
    xxSpacing: `48px`,
    borderRadius: `6px`
}

export const btnReset = css`
    font-family: inherit;
    outline: none;
    border: none;
    background: none;
    letter-spacing: inherit;
    color: inherit;
    font-size: inherit;
    text-align: inherit;
    padding: 0;
`;
